<template>
  <div class="table-container">
    <div class="table-responsive table-scrollable table-scrollable-size-20" v-if="items?.length > 0">
      <table class="table table-striped c-table">
        <thead>
        <tr class="sticky-header">
          <th>ردیف</th>
          <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
          <th>فرمول نماگر</th>
          <th>بروزرسانی فرمول</th>
          <th class="nowrap">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td class="vw-3">{{ index + 1 }}</td>
          <td v-for="field in fields" :key="field">
            <span>{{ !!item[field] ? item[field] : '...' }}</span>
          </td>
          <td>
            <SmartFormula
                v-if="item.formula && variables.length"
                :formula="item.formula"
                :variables="variables"
            />
            <span v-else>...</span>
          </td>
          <td class="vw-10">
            <a
                class="btn btn-primary btn-submit-1 p-3"
                type="button"
                @click="openCompleteFormulaModalMethod(item, index)"
            >
              تکمیل / بروزرسانی
            </a>
          </td>
          <td class="vw-5">
            <a
                type="button"
                @click="openEditModalMethod(item, index)"
            >
              <img class="table-edit-img" src="../../../assets/img/pen.svg" alt="edit" title="ویرایش">
            </a>
            <a type="button" class="ms-2" @click="openDeleteModal(index)">
              <img class="table-delete-img" src="../../../assets/img/delete.svg" alt="delete" title="حذف">
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="alert alert-info m-3">
      موردی وجود ندارد
    </div>

    <ConfirmModal
        ref="confirmModal"
        v-show="deleteIndex"
        title="حذف"
        message="آیا از حذف مطمئن هستید؟"
        @closed="closeModal"
        @confirmed="confirmRemove"
    />
  </div>
</template>

<script>
import ConfirmModal from "@/components/GeneralComponents/ConfirmModal.vue";
import SmartFormula
  from "@/components/Financial_management_and_productivity/DefineProductivityRepresentations/SmartFormula.vue";

export default {
  components: {SmartFormula, ConfirmModal},
  props: {
    headers: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    variables: {
      type: Array,
      required: true
    },
    openEditModalMethod: {
      type: Function,
      required: true
    },
    openCompleteFormulaModalMethod: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      deleteIndex: null
    }
  },
  methods: {
    openDeleteModal(index) {
      this.deleteIndex = index;
      this.$refs.confirmModal.openConfirmModal()
    },
    closeModal() {
      this.deleteIndex = null;
    },
    confirmRemove() {
      this.$emit('remove', this.deleteIndex);
      this.deleteIndex = null;
    }
  }
};
</script>

<style scoped>
.btn-primary.btn-submit-1 {
  min-width: 8vw !important;
  margin: 0 auto;
}

.vw-10 {
  width: 10vw;
}
</style>
